<template>
  <v-container>

    <v-expansion-panels v-model="panel" multiple class="mb-3">
      <v-expansion-panel class="mt-4">
        <v-expansion-panel-header class="grey lighten-2" >
          Próximos Eventos
          <template v-slot:actions>
            <v-icon>mdi-menu-down</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <next-events />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mt-4">
        <v-expansion-panel-header class="grey lighten-2">
          Minhas Estatísticas de Consultas
          <template v-slot:actions>
            <v-icon>mdi-menu-down</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <statistics />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-row no-gutters align="center" style="height: 150px;" class="pa-0 ma-0">
      <v-col align-self="start" class="pa-0 ma-0">
      </v-col>
      <v-col align-self="center" class="pa-0 ma-0">
        <v-hover v-slot="{ hover }">
          <v-card class="pa-0 ma-0" :elevation="hover ? 5 : 0" outlined tile>
            <v-img
              contain
              style="cursor: pointer;"
              src="@/assets/banner_clube.png"
              @click="clickBannerClub"
              class="pa-0 ma-0"
            ></v-img>
          </v-card>
        </v-hover>
      </v-col>
      <v-col align-self="end" class="pa-0 ma-0">
      </v-col>
    </v-row>

    <v-btn dark fixed bottom right fab to="/calendar/filter" color="red darken-4">
      <v-icon>mdi-calendar-plus</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import Statistics from '@/components/dashboard/Statistics';
import NextEvents from '@/components/dashboard/NextEvents';

export default {
  data: () => ({
    panel: [0, 1],
  }),
  computed: {
    hoverClass() {
      return {
        cursor: 'pointer',
      };
    },
  },
  methods: {
    click() {
      this.$router.push({ name: 'calendar-filter' });
    },
    clickBannerClub() {
      window.open('https://www.tendamia.com.br/pages/medibook-cupons');
    },
  },
  components: {
    Statistics,
    NextEvents,
  },
};
</script>
